<template>
	<div>
		<div style="text-align:center; position:relative" v-if="loading">
			<fa :icon="['fab', 'paypal']" style="color:#003087"></fa>
			<div style="position:relative; top:-35px;">
				<fa icon="spinner" size="3x" pulse style="color:#ffc439"></fa>
			</div>
		</div>
		<div style="text-align:center" v-show="!loading">
			<div style="margin-bottom:5px" v-show="canReload">
				<b-button type="is-primary" @click="Render()">Start Over</b-button>
			</div>
			<div id="paypal-button-container"></div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "paypal",
		data: function () {
			return {
				clientId: undefined,
				env: 'production',
				checkout: undefined,
				loading: true,
				canReload: false
			}
		},
		props: {
			value: {
				type: [Object, String],
				default: undefined
			},
			products: {
				type: Array,
				default: () => { return []; }
			},
			plan: {
				type: String,
				default: undefined
			}
		},//["value", "products", "plan"],
		watch: {
			products: {
				handler(n, o) {
					this.UpdateProducts();
				},
				deep: true
			}
		},
		methods: {
			//ViewPlans() {
			//  this.$http.get("api/payment").then(resp => {
			//    console.log(resp);
			//  });
			//},
			UpdateProducts() {
				if (this.checkout) {
					this.checkout.updateProps();
				}
			},
			Render() {
				var self = this;
				if (self.checkout)
					self.checkout.close();

				self.loading = true;
				self.canReload = false;
				if (self.plan) {
					var checkout = paypal.Buttons({
						env: self.env,
						enableStandardCardFields: true,
						createSubscription(data, actions) {
							self.$emit("create", data);
							if (self.plan)
								return actions.subscription.create({
									plan_id: self.plan
								})
						},
						onError(err) {
							self.canReload = true;
							console.error(err);
						},
						onApprove(data, actions) {
							data.id = data.orderID;
							self.$emit("completing");
							self.$emit("complete", data);
						}
					});
				}
				else {
					var checkout = paypal.Buttons({
						env: self.env,
						enableStandardCardFields: true,
						createOrder(data, actions) {
							self.$emit("create");
							return actions.order.create({
								intent: "CAPTURE",

								purchase_units: self.products

							});
						},
						onError(err) {
							self.canReload = true;
							console.error(err);
						},
						onApprove(data, actions) {
							self.$emit("completing");
							return actions.order.capture().then((details) => {
								self.$emit("complete", details);
							});
						}
					});
				}
				self.checkout = checkout;
				self.$emit("input", self.checkout);
				checkout.render("#paypal-button-container").then((resp) => {
					self.$nextTick(() => {
						self.loading = false;
						self.$emit("ready", self.checkout);
					});
				});
			}
		},
		created() {
			this.clientId = this.$options.options.clientId;
			this.env = this.$options.options.env;
		},
		mounted() {
			let smartPaypalScript = document.createElement('script');
			smartPaypalScript.setAttribute('src', "https://www.paypal.com/sdk/js?client-id=" + this.clientId + "&currency=USD");
			document.head.appendChild(smartPaypalScript);
			smartPaypalScript.onload = () => {
				this.Render();
			};

		}
	}
</script>
